<div class="empty-cart" role="status">
  <span class="empty-cart__icon"><i class="pi pi-shopping-cart" aria-hidden="true"></i></span>
  <p class="empty-cart__title">Cart is empty</p>
  <p class="empty-cart__text">
    {{ barcodeEnabled ? "Scan a barcode or search for a product to start the bill." : "Search for a product to start the bill." }}
  </p>
  <ul class="empty-cart__keys">
    <li *ngIf="barcodeEnabled"><span class="kbd">Ctrl</span><span class="kbd">1</span> Scan barcode</li>
    <li><span class="kbd">Ctrl</span><span class="kbd">2</span> Search product</li>
    <li><span class="kbd">F6</span> Resume held bill</li>
  </ul>
</div>
